import React from 'react'
import { Link } from 'gatsby'

const Item = ({ slug, avatar, headLine, title }) => {
  const { file: { url, fileName } } = avatar
  return (
    <div className='item margin-lr-15px'>
      <div className='testimonial-item layout-3'>
        <div className='text-content box-shadow'>
          <div className='truncate-text-profile'>
            <p>{headLine}</p>
            <div className='icon' />
          </div>
        </div>
        <div className='img-in'>
          <img src={url} alt={fileName} />
        </div>
        <Link to={`/post/${slug}`}><span className='margin-bottom-0px'>{title}</span></Link>
      </div>
    </div>
  )
}

export default Item
